import apiClient from '@u/apiClient.js'

export default {
  getCondolencesList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`condolence`, {
          params: payload.params
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  sendAllCondolences({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`condolence/send-all`, payload.params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  sendCondolence({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`condolence/${payload.condolence_id}/send`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  deleteCondolence({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .delete(`condolence/${payload.condolence_id}`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
